import axios from "axios";

const atlasAxios = axios.create({
  baseURL: process.env.REACT_APP_ATLAS_URL,
  headers: {
    "X-API-Key": process.env.REACT_APP_ATLAS_API_KEY,
    "Content-Type": "application/json",
  },
});

// GET agents aktif dari Atlas knowledge-base — dipakai untuk pilihan Agent di form Channel
export const getAtlasAgents = async () => {
  try {
    const response = await atlasAxios.get("/api/knowledge-base/agents", {
      params: { page: 1, per_page: 100, status: "active" },
    });
    return response;
  } catch (error) {
    return error.response || { status: "No Server Response" };
  }
};
